<main class="flex flex-col h-screen overflow-hidden">
  <header>
    <div class="healine">
      <h1>{{ 'productionCardsDetails.productionCardsFor' | translateWF: 'Production Cards for' }} {{ workOrder ? workOrder.orderNumber : '' }}</h1>
    </div>
    <div class="buttons">
      <p-splitbutton [label]="'Save' | translateWF: 'Save'" (onClick)="onSubmit(false)" [disabled]="disabledBtnByViewers()" [model]="saveMenuItems" />

      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <div class="row-end-center">
      <p-button
        [icon]="showRightPanel() ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"
        [text]="true"
        (click)="toggleRightPanel()"
        [pTooltip]="showRightPanel() ? 'Hide Details' : 'Show Details'"
        tooltipPosition="left"
      />
    </div>

    <!-- Grid: On mobile always 1 col. On XL, 2 cols IF panel visible. -->
    <div class="grid gap-4 overflow-hidden transition-all duration-300" [ngClass]="showRightPanel() ? 'grid-cols-1 xl:grid-cols-[1fr_minmax(460px,35%)]' : 'grid-cols-1'">
      <div class="col-lg scroller-y">
        <div class="flex items-center justify-between w-full">
          <p-selectbutton [formControl]="dataView" [options]="dataOptions" optionLabel="label" optionValue="value" />
          <!-- Sección de planning -->
          @if (dataView.value === 'planning' || dataView.value !== 'programming') {
            <p-selectbutton [formControl]="planningView" [options]="planningOptions" optionLabel="label" optionValue="value" />
          }
        </div>

        @if (dataView.value === 'planning' || dataView.value !== 'programming') {
          @if (planningView.value === 'overview') {
            <app-work-order-summary-viewer *ngIf="workOrder && showOverview" [workOrder]="workOrder" [colors]="allColors" />
          } @else {
            <p-panel [header]="'productionCardsDetails.groups' | translateWF: 'Groups'">
              <ng-template pTemplate="icons">
                <p-button [label]="'productionCardsDetails.addAllForecast' | translateWF: 'Add all forecast'" [disabled]="disabledBtnByViewers()" />
              </ng-template>

              <p-panel header="Forecasts" data-tone="surface">
                <div class="col-sm">
                  <div class="row-between-end">
                    <p-selectbutton [formControl]="filterForecastCreated" [options]="forecastFilterOptions" optionLabel="label" optionValue="value" class="w-auto" />
                    <p-button
                      variant="outlined"
                      [label]="'productionCardsDetails.addNewForecast' | translateWF: 'Add Forecast'"
                      (click)="addNewForecast()"
                      [disabled]="disabledBtnByViewers()"
                    />
                  </div>

                  <!-- Forecast viewers are already tiles: no card wrap -->
                  @for (dyeingFormGroup of filteredDyeingForecasts; track $index) {
                    <app-dyeing-forecast-viewer [colors]="allColors" [assets]="allAssets" [dyeingGroups]="dyeingGroups" [dyeingForecastFormGroup]="dyeingFormGroup" />
                  }
                </div>
              </p-panel>
            </p-panel>
          }
        }

        @if (dataView.value === 'programming') {
          <ng-container>
            <!-- List of cards section -->
            <p-panel>
              <ng-template pTemplate="header">
                <span class="font-semibold">{{ 'productionCardsDetails.productionCards' | translateWF: 'Production Cards' }} ({{ productionCardsFormArray.length }})</span>
              </ng-template>

              <ng-template pTemplate="icons">
                <p-button
                  variant="outlined"
                  [label]="'productionCardsDetails.addProductionCard' | translateWF: 'Add Production Card'"
                  (click)="addProductionCard()"
                  [disabled]="blockBtnAddCard() || disabledBtnByViewers()"
                />
              </ng-template>
              @if (workOrder) {
                <!-- productions cards: shared component, no card wrap -->
                <app-production-cards-viewer [workOrder]="workOrder" [readonly]="disabledBtnByViewers()" [includeDeleted]="true" />
              }
            </p-panel>
          </ng-container>
        }
      </div>

      <!-- Right Panel:
           Mobile/Tablet (<xl): Absolute overlay, slides in/out.
           Desktop (>=xl): Static grid column, hides if !showRightPanel.
      -->
      <div
        class="details-side-panel scroller-y"
        [ngClass]="{
          'translate-x-full xl:hidden': !showRightPanel(),
          'translate-x-0 xl:block': showRightPanel(),
        }"
      >
        @if (productOrder) {
          <app-production-card-details />
        } @else {
          <app-dyeing-details-card *ngIf="workOrder" [assets]="allAssets" [workOrder]="workOrder" [onlyView]="disabledBtnByViewers()" />
        }
      </div>
    </div>
  </div>
</main>
